import * as OrderMiscCommon from './clientlogs/order-misc-common-txtpb'
import * as GlobalOrderAccommodationsAbroadCommon from './global/order-accommodations-abroad-common-txtpb'
import { wrapObjectMethodsWithLogging } from './utils'

export const CartOrderPageLog = wrapObjectMethodsWithLogging(OrderMiscCommon.CartOrderPageLog)
export const CartOrderCompletePageLog = wrapObjectMethodsWithLogging(
  OrderMiscCommon.CartOrderCompletePageLog
)
export const CartOrderListPageLog = wrapObjectMethodsWithLogging(
  OrderMiscCommon.CartOrderListPageLog
)
export const CartOrderDetailPageLog = wrapObjectMethodsWithLogging(
  OrderMiscCommon.CartOrderDetailPageLog
)
export const CartOrderCancelPageLog = wrapObjectMethodsWithLogging(
  OrderMiscCommon.CartOrderCancelPageLog
)

export const GlobalOrderPageLog = wrapObjectMethodsWithLogging(
  GlobalOrderAccommodationsAbroadCommon.GlobalOrderPageLog
)

export const GlobalOrderStatusPageLog = wrapObjectMethodsWithLogging(
  GlobalOrderAccommodationsAbroadCommon.GlobalOrderStatusPageLog
)

export const GOrderDetailPageLog = wrapObjectMethodsWithLogging(
  GlobalOrderAccommodationsAbroadCommon.GOrderDetailPageLog
)

export const GlobalOrderCancelPageLog = wrapObjectMethodsWithLogging(
  GlobalOrderAccommodationsAbroadCommon.GlobalOrderCancelPageLog
)

export const GOrderListPageLog = wrapObjectMethodsWithLogging(
  GlobalOrderAccommodationsAbroadCommon.GOrderListPageLog
)

export const GlobalPaymentPageLog = wrapObjectMethodsWithLogging(
  GlobalOrderAccommodationsAbroadCommon.GlobalPaymentPageLog
)